




















import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import Popper from 'popper.js';

@Component
export default class GripButtion extends Vue {
  //buttonプロパティにリダイレクトする
  @Prop() public caption: string;
  @Prop() public icon: string;
  @Prop({default:null}) public sc: string;
  @Prop({default:null}) public tooltip: string;
  @Prop({default:false}) public disabled: boolean;
  @Prop({default:null}) public perm: string;
  @Prop({default:null}) public buttonStyle: string;
  @Prop({default:null}) public svg: string;
  @Prop({default:false}) public target: boolean;
  @Prop({default:false}) public gripDisabled: boolean;

  public eventEnabled :boolean = false;
  public draggable: boolean = false;

  public mounted(){
    this.eventEnabled = this.$el.parentElement.classList.contains('cx_appevent_enabled');
  }
  public onClick(){
    this.$emit('click');
  }
  public onMouseDown(){
    if (this.disabled == false){
      this.draggable = true;
    }
  }
  public onOver(event:any){
    if(this.disabled == false){
      this.$emit('dragover',event);
    }
  }
  public onDrop(event:any){
    if(this.disabled == false){    
      this.$emit('drop',event);
      this.draggable = false;
    }
  }
  public onLeave(){
    if (this.disabled == false){
      this.$emit('dragleave');    
      this.draggable = false;
    }
  }
}
